module.exports = __webpack_public_path__ + "img/align_vertical_center.a1c7a601.svg";